module.exports = __webpack_public_path__ + "img/default-avatar.aec59939.png";